import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import localData from "../../localData";

export default function CustomSwiper({ items, Card, options = {} }) {
    const { angleLeft, angleRight } = localData.svgs;
    const { preloader } = localData.images;

    const navigationPrevRef = React.useRef(null);
    const navigationNextRef = React.useRef(null);

    const swiperRef = useRef(null);
    return (
        <>
            {!items || !Object.keys(items).length ? (
                <img src={preloader} width="300" />
            ) : (
                <div
                    className="swiper-custom-wrapper"
                    onMouseEnter={() => swiperRef.current.swiper.autoplay.stop()}
                    onMouseLeave={() => swiperRef.current.swiper.autoplay.start()}
                >
                    <div className="swiper-custom-center">
                        <span className="swiper-custom-angle swiper-custom-angle-left" ref={navigationPrevRef}>
                            {angleLeft}
                        </span>
                        <span className="swiper-custom-angle swiper-custom-angle-right" ref={navigationNextRef}>
                            {angleRight}
                        </span>
                    </div>

                    <Swiper
                        ref={swiperRef}
                        // touchStartPreventDefault={false}
                        loop={true}
                        speed={options.speed || 3000}
                        autoplay={options.autoplay }
                        centeredSlides={true}
                        modules={[Pagination, Autoplay, Navigation]}
                        spaceBetween={options.spaceBetween || 30}
                        slidesPerView={options.slidesPerView||"auto"} 
                        // onSlideChange={() => console.log("slide change")}
                        // onSwiper={(swiper) => console.log(swiper)}
                        navigation={{
                            prevEl: navigationPrevRef.current,
                            nextEl: navigationNextRef.current,
                        }}
                        onBeforeInit={(swiper) => {
                            swiper.params.navigation.prevEl = navigationPrevRef.current;
                            swiper.params.navigation.nextEl = navigationNextRef.current;
                        }}
                        pagination={options.pagination || false}
                        // scrollbar={{ draggable: true }}
                        // breakpoints={
                        //     options.breakpoints || {
                        //         // when window width is >= 640px
                        //         640: {
                        //             //   width: 640,
                        //             slidesPerView: 3,
                        //         },
                        //         // when window width is >= 768px
                        //         768: {
                        //             //   width: 768,
                        //             slidesPerView: 3,
                        //         },
                        //         992: {
                        //             slidesPerView: 5,
                        //         },
                        //     }
                        // }
                    >
                        {items.map((item, index) => {
                            return (
                                <SwiperSlide key={index}>
                                    <Card {...item} />
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>
            )}
        </>
    );
}
